<template>
    <div class="verified-input-tel">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <div :class="{ 'field has-addons': icon || (hideInfo && innerHideInfo) }">
            <div class="control" v-if="innerHideInfo">
                <a
                    class="button"
                    @click="innerInfoIsHidden = !innerInfoIsHidden"
                    :class="{ 'invalid-button-before': focusedOut && invalid }"
                >
                    <b-icon v-if="!innerInfoIsHidden" icon="eye-off-outline" type="is-danger" />
                    <b-icon v-if="innerInfoIsHidden" icon="eye-outline" type="is-success" />
                </a>
            </div>
            <div
                :class="{ 'control is-expanded': icon || (hideInfo && innerHideInfo) }"
                v-if="started"
            >
                <vue-tel-input
                    v-if="started"
                    ref="vueTelInput"
                    :id="innerId"
                    :defaultCountry="countryCode"
                    v-model="innerValue"
                    @blur="blurEvt()"
                    @focus="focusEvt()"
                    @input="updateValue"
                    class="input-tel"
                    :class="{
                        invalid: focusedOut && invalid && innerInvalidWhenDisabled,
                        'text-uppercase': uppercase,
                        'input-icon': icon,
                        'input-hide': hideInfo,
                        'hidden-field': hideInfo && innerInfoIsHidden
                    }"
                    :disabled="disabled"
                    :readonly="readonly"
                    :tabindex="tabindex"
                    :preferredCountries="preferredCountries"
                    :validCharactersOnly="true"
                    :inputOptions="inputOptions"
                    @validate="inputValidate"
                    @country-changed="countryChanged"
                />
                <v-input v-else placeholder="carregando" :disabled="true" />
            </div>
            <div class="control" v-if="icon && value != null && value != ''">
                <span v-if="iconTooltip" v-tippy :title="$t(iconTooltip)">
                    <VerifieldInputIcon
                        :icon="icon"
                        :iconSvg="iconSvg"
                        :focusedOut="focusedOut"
                        :invalid="invalid"
                        @inputAction="inputAction"
                    />
                </span>
                <template v-else>
                    <VerifieldInputIcon
                        :icon="icon"
                        :iconSvg="iconSvg"
                        :focusedOut="focusedOut"
                        :invalid="invalid"
                        @inputAction="inputAction"
                    />
                </template>
            </div>
        </div>
        <span
            class="validation"
            v-text="getT(msg)"
            v-if="focusedOut && invalid"
        />
        <div class="clearfix" v-else-if="innerInvalidWhenDisabled && !noClearfix" />
    </div>
</template>


<script>
/* Como usar
<v-input-tel
    ref="celularInput"
    :hideInfo="hide.hideInfo"
    :infoIsHidden="hide.infoIsHidden"
    v-model="celular"
    title="celular"
    :edit="checkEditTel(telefone)"
/>
checkEditTel(val){ return(this.$route.params.id&&val!=null&&val!=''&&val!='
'&&val!=undefined&&val!='null'); } */
import allCountries from '@/assets/all-countries.js';
import VerifiedLable from '@/components/shared/VerifiedLable.vue';
import VerifieldInputIcon from '@/components/shared/VerifieldInputIcon.vue';

export default {
    components: {
        VerifiedLable,
        VerifieldInputIcon,
    },
    props: {
        value: {
            default: null,
        },
        //edit deve ser verdadeiro caso value seja nulo, a fim de não ocasionar problemas nas verificações e validações realizadas no componente
        edit: {
            default: false,
            type: Boolean,
        },
        id: {
            default: null,
        },
        preferredCountries: {
            default: () => ['BR', 'PY', 'AR', 'UY', 'CL', 'BO', 'PE', 'EC', 'CO', 'VE'],
            type: Array,
        },
        placeholder: {
            default: '',
            type: String,
        },
        maxlength: {
            default: 17,
            type: Number,
        },
        title: {
            default: '',
            type: String,
        },
        type: {
            default: 'text',
            type: String,
        },
        msg: {
            default: 'msg-campo-requiredtorio',
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        invalidWhenDisabled: {
            type: Boolean,
            default: false,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        readonly: {
            default: false,
            type: Boolean,
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        onBlurFunction: {
            default: () => {},
            type: Function,
        },
        onFocus: {
            default: () => {},
            type: Function,
        },
        icon: {
            default: '',
            type: String,
        },
        // true caso seja um ícone baixado
        iconSvg: {
            type: Boolean,
            default: false,
        },
        iconTooltip: {
            default: null,
            type: String,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
        validchars: {
            type: String,
            default: '',
        },
        uppercase: {
            type: Boolean,
            default: true,
        },
        noClearfix: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            type: String,
            default: null,
        },
        /* Ativa a ocultação da informação - Ativa o olho de visualizar/ocultar
        Adicionar no componente pai
        Adicionar no <v-input 
            :hideInfo="true"
            :infoIsHidden="hide.infoIsHidd
    */
        hideInfo: {
            type: Boolean,
            default: false,
        },
        infoIsHidden: {
            type: Boolean,
            default: true,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },

        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
    },
    data() {
        return {
            countries: allCountries,
            innerId: null,
            innerValue: null,
            started: false,
            focusedOut: false,
            innerHideInfo: this.hideInfo,
            innerInfoIsHidden: this.infoIsHidden,
            inputOptions: {
                maxlength: this.maxlength,
                type: this.type,
                placeholder: null,
            },
            countryCode: 'BR',
            innerValueStarted: false,
            innerInvalidWhenDisabled: false,
        };
    },
    mounted() {
        this.focusedOut = !this.onBlur;
    },
    created() {
        this.inputOptions.placeholder = this.disableMLplaceholder
            ? this.placeholder
            : this.getT(this.placeholder, '(00) 0000-0000');

        if (this.id == null) {
            this.innerId = new Date().getTime() + '' + Math.floor(Math.random() * 10000);
        } else {
            this.innerId = this.id;
        }
        if (this.edit && this.checkEditTel(this.value)) {
            this.validaInicializacao(this.value);
        } else if (!this.edit && this.checkEditTel(this.value)) {
            this.validaInicializacao(this.value);
        } else {
            this.started = true;
        }

        this.innerInvalidWhenDisabled =
            !this.disabled || (this.invalidWhenDisabled && this.disabled);
    },
    watch: {
        edit(val) {
            this.innerValueStarted = false;
            this.innerValue = null;
            this.started = false;
            if (this.checkEditTel(this.value) && val) {
                this.validaInicializacao(this.value);
            } else {
                this.started = true;
            }
        },
        innerValue(val) {
            if (!this.innerValueStarted && (val == '' || val == null))
                this.innerValueStarted = true;
            if (this.started && val == '') this.$emit('input', val);
        },
        type(val) {
            this.inputOptions.type = val;
        },
        hideInfo(val) {
            this.innerHideInfo = val;
        },
        infoIsHidden(val) {
            this.innerInfoIsHidden = val;
        },
    },
    methods: {
        checkEditTel(val) {
            return val != null && val != '' && val != ' ' && val != undefined && val != 'null';
        },
        validaInicializacao(val) {
            let format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/g;
            let valFormated = null;

            if (format.test(val)) {
                valFormated = val.replace(format, '');
            } else {
                valFormated = val;
            }

            if ((this.innerValue == '' || this.innerValue == null) && !this.started) {
                if (valFormated.charAt(0) >= '0' && valFormated.charAt(0) <= '9') {
                    this.innerValue = valFormated;
                } else {
                    let split = valFormated.split(' ');
                    let code = this.countries.filter((c) => c.iso2 == split[0].toUpperCase())[0];
                    if (code) {
                        this.countryCode = code.iso2;
                        this.innerValue = split[1];
                    } else {
                        this.countryCode = 'BR';
                        this.innerValue = val;
                    }
                }
                setTimeout(() => {
                    this.started = true;
                }, 300);
            }
        },
        countryChanged(val) {
            this.countryCode = val.iso2.toUpperCase();
            this.updateValue(this.innerValue);
        },
        inputValidate(val) {
            this.$emit('inputValidate', val);
        },
        updateValue(val) {
            if (this.innerValue && this.started) {
                val = val.replaceAll(/[-()+ ]/g, '');
                if (val.length <= this.maxlength) {
                    let input = this.countryCode + ' ' + val;
                    this.emitValue(input);
                } else {
                    // console.log('Inválido');
                }
            }
        },
        emitValue(value) {
            this.$emit('input', value);
        },
        inputAction() {
            this.$emit('input-action');
        },
        focusEvt() {
            this.focusedOut = false;
            if (this.onFocus) {
                this.onFocus();
            }
        },
        blurEvt() {
            this.focusedOut = true;
            if (this.onBlur) {
                this.onBlurFunction();
            }
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep input::placeholder { font-family: "Montserrat", sans-serif; }
::v-deep input:-ms-input-placeholder { font-family: "Montserrat", sans-serif; }
::v-deep input::-ms-input-placeholder { font-family: "Montserrat", sans-serif; }

::v-deep .hidden-field > input {
    font-family: text-security-disc; 
    -webkit-text-security: disc;
    color: $text-color;
}

label {
    font-size: 12px;
    color: #666666;
    font-weight: 600;
}
.label-required {
    color: $primary-color;
}
span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}
.verified-input-tel .disabled {
    opacity: 1;
}

input {
    margin-bottom: 0 !important;
    color: #666666;
    height: 36px;
}
.input-hide {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.input-icon {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.field.has-addons {
    margin-bottom: 0;
    .button {
        height: 36px;
        color: #666666;
        border-color: $table-border;

        &.invalid-button-before {
            border-bottom-color: red;
            border-left-color: red;
            border-top-color: red;
        }
        &.invalid-button-after {
            border-bottom-color: red;
            border-right-color: red;
            border-top-color: red;
        }
    }
}

.clearfix {
    height: 12px;
}

.b-tooltip {
    background-color: inherit;
}
</style>
